<template>
    <div>

        <b-row>
            <b-col class="text-center">
                <b-button :variant="form_control ? 'secondary' : 'outline-secondary'"
                          size="sm"
                          @click="form_control = true"
                          class="mx-1 mb-2 mt-3"
                >
                    <i class="fa fa-plus"/>
                    <span class="d-none d-md-inline-block ml-1"
                          v-text="' Formulario'"
                    />
                </b-button>

                <b-button :variant="!form_control ? 'secondary' : 'outline-secondary'"
                          size="sm"
                          @click="form_control = false"
                          class="mx-1 mb-2 mt-3"
                          :disabled="!task.controls.length"
                >
                    <i class="fa fa-list-ol"/>
                    Listado
                    <b-badge v-if="!!task.controls.length"
                             :variant="form_control ? 'danger' : 'light'"
                             pill
                    >
                        {{ task.controls.length }}
                    </b-badge>
                </b-button>
            </b-col>
        </b-row>


        <transition mode="out-in"
                    name="component-fade"
        >
            <b-form @submit.prevent="validateFormControls()"
                    data-vv-scope="task_control"
                    v-if="form_control"
            >
                <b-row>
                    <b-col cols="12">
                        <b-form-group>
                            <label for="step_order">Tareas</label>
                            <el-select v-model="task_control.step_order"
                                       id="step_order"
                                       name="step_order"
                                       filterable
                                       size="small"
                                       placeholder="Seleccione una tarea"
                                       class="w-100"
                                       no-data-text="No hay datos que coincidan"
                                       no-match-text="No hay datos que coincidan"
                                       data-vv-as=" "
                                       v-validate=""
                                       multiple
                            >
                                <el-option v-for="step in task.steps"
                                           :key="step.id"
                                           :label="step.name"
                                           :value="step.id"
                                />
                            </el-select>
                            <div class="text-danger small"
                                 v-text="errors.first('task_control.step_order')"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col cols="12">
                        <b-form-group>
                            <label for="sys_list_type_id">Tipo</label>
                            <el-select v-model="task_control.sys_list_type_id"
                                       id="sys_list_type_id"
                                       name="sys_list_type_id"
                                       filterable
                                       size="small"
                                       placeholder="Seleccione un tipo"
                                       class="w-100"
                                       no-data-text="No hay datos que coincidan"
                                       no-match-text="No hay datos que coincidan"
                                       data-vv-as=" "
                                       v-validate="'required'"
                            >
                                <el-option v-for="type in types"
                                           :key="type.id"
                                           :label="type.lista"
                                           :value="type.id"
                                />
                            </el-select>
                            <div class="text-danger small"
                                 v-text="errors.first('task_control.sys_list_type_id')"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col cols="12">
                        <b-form-group>
                            <label for="description">Descripción</label>
                            <el-input id="description"
                                      name="description"
                                      type="textarea"
                                      size="small"
                                      v-model="task_control.description"
                                      data-vv-as=" "
                                      v-validate="'required|min:3|max:1000'"
                                      maxlength="1000"
                                      show-word-limit
                            />
                            <div class="text-danger small"
                                 v-text="errors.first('task_control.description')"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col cols="12"
                           v-show="!task_control.url"
                    >
                        <b-form-file id="image"
                                     name="image"
                                     v-model="task_control.image"
                                     data-vv-as=" "
                                     v-validate="'required|mimes:image/jpeg,image/png,image/jpg'"
                                     accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                     data-vv-delay="1000"
                                     placeholder="Elija un archivo o suéltelo aquí..."
                                     drop-placeholder="Suelta el archivo aquí..."
                                     @change="onFileChange"
                        />
                        <span class="text-danger small"
                              v-text="imageTypeError || errors.first('task_control.image')"
                        />
                    </b-col>

                    <b-col cols="12"
                           class="text-center"
                           v-if="task_control.url"
                    >
                        <b-img :src="task_control.url"
                               thumbnail
                               rounded
                               fluid
                               alt="task"
                               style="max-height: 200px; max-width: 200px"
                        />

                        <br>

                        <el-tooltip popper-class="py-1 px-2"
                                    effect="dark"
                                    placement="bottom"
                                    content="Eliminar imagen"
                        >
                            <b-btn variant="danger"
                                   class="m-1"
                                   size="sm"
                                   @click="setUrlToTaskControl(null)"
                            >
                                <i class="fa fa-trash"/> Eliminar
                            </b-btn>
                        </el-tooltip>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col class="text-center">
                        <hr/>

                        <b-btn variant="primary"
                               class="mx-1"
                               @click="validateFormControls()"
                        >
                            <i class="fa fa-save"/>
                            <span v-if="editing_control">
                                Aceptar
                            </span>
                            <span v-else>
                                Crear
                            </span>
                        </b-btn>
                        <b-btn variant="secondary"
                               class="mx-1"
                               @click="_resetTaskControl()"
                        >
                            <i class="fa fa-close"/> Cancelar
                        </b-btn>
                    </b-col>
                </b-row>
            </b-form>

            <table v-else
                   class="table table-striped table-sm table-hover"
            >
                <thead class="text-white"
                       style="background-color: #097b83"
                >
                <tr>
                    <th>Tipo</th>
                    <th>Nombre</th>
                    <th>Descripción</th>
                    <th></th>
                    <th width="90px">Acciones</th>
                </tr>
                </thead>
                <tbody>
                <template v-if="!!task.controls.length">
                    <tr v-for="control in task.controls"
                        :key="control.name"
                    >
                        <td>{{ control.sys_list_type.lista }}</td>
                        <td>{{ control.name }}</td>
                        <td>{{ control.description }}</td>
                        <td>
                            <b-img :src="control.url"
                                   thumbnail
                                   rounded
                                   fluid
                                   alt="task"
                                   style="max-height: 50px; max-width: 50px"
                            />
                        </td>
                        <td>
                            <el-tooltip popper-class="py-1 px-2"
                                        effect="dark"
                                        placement="top-start"
                                        content="Editar"
                            >
                                <b-btn variant="primary"
                                       class="mx-1"
                                       size="sm"
                                       @click="_setTaskControl(control)"
                                >
                                    <i class="fa fa-edit"/>
                                </b-btn>
                            </el-tooltip>

                            <el-tooltip popper-class="py-1 px-2"
                                        effect="dark"
                                        placement="top-start"
                                        content="Eliminar"
                            >
                                <b-btn variant="danger"
                                       class="mx-1"
                                       size="sm"
                                       @click="questionDelete(control)"
                                >
                                    <i class="fa fa-trash"/>
                                </b-btn>
                            </el-tooltip>
                        </td>
                    </tr>
                </template>
                <tr v-else>
                    <td colspan="4"
                        class="text-center"
                    >
                        No hay controles para mostrar
                    </td>
                </tr>
                </tbody>
            </table>
        </transition>

        <b-row>
            <b-col>
                <hr/>
                <b-btn variant="secondary"
                       class="float-left"
                       size="sm"
                       @click="setModalShow(false)"
                >
                    <i class="fa fa-close"/> Cancelar
                </b-btn>

                <b-btn variant="primary"
                       class="float-right ml-2"
                       size="sm"
                       @click="finalize()"
                       :disabled="!task.controls.length"
                >
                    Guardar
                    <i class="fa fa-save"/>
                </b-btn>
                <b-btn variant="info"
                       class="float-right"
                       size="sm"
                       @click="decreaseStepToModal"
                >
                    <i class="fa fa-arrow-left"/> Anterior
                </b-btn>
            </b-col>
        </b-row>
    </div>
</template>


<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import Swal from 'sweetalert2';

export default {
    name: 'controls',
    data() {
        return {
            form_control: true,
            imageTypeError: ''
        };
    },
    computed: {
        ...mapState('tasks', [
            'task',
            'task_control',
            'editing',
            'editing_control',
            'modal',
            'types',
            'editing'
        ])
    },
    mounted(){
        this.form_control = !this.editing
    },
    watch: {
        'task.steps': {
            handler() {
                this.cleanStepOrder();
            },
            deep: true
        }
    },
    methods: {
        ...mapActions('tasks', [
            'addTask',
            'updateTask'
        ]),
        ...mapMutations('tasks', [
            'decreaseStepToModal',
            'resetTaskControl',
            'addControl',
            'updateControl',
            'setControlsToTask',
            'setTaskControl',
            'setEditingControl',
            'setUrlToTaskControl',
            'setModalShow'
        ]),
        // Limpia el step_order para que solo contenga IDs de pasos válidos
        cleanStepOrder() {
            if (this.task_control.step_order && Array.isArray(this.task_control.step_order)) {
                const validIds = this.task.steps.map(step => step.id);
                this.task_control.step_order = this.task_control.step_order.filter(id => validIds.includes(id));
            }
        },
        _setTaskControl(control) {
            this.setTaskControl(control);
            
            // Asegura que step_order tenga los IDs de los pasos asociados
            if (control.steps && Array.isArray(control.steps)) {
                this.task_control.step_order = control.steps.map(step => step.id);
            } else {
                this.task_control.step_order = [];
            }

            this.cleanStepOrder();
            this.setEditingControl(true);
            this.form_control = true;
        },
        _resetTaskControl() {
            this.resetTaskControl();
            this.setEditingControl(false);
            this.imageTypeError = '';
        },
        async questionDelete(control) {
            await Swal.fire({
                title: 'Eliminar',
                text: `¿Está seguro de eliminar el control?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Si, eliminar'
            }).then(async (result) => {
                if (result) {
                    const controls = this.task.controls.filter(c => c.id !== control.id);

                    this.setControlsToTask(controls);

                    if (!controls.length) {
                        this.form_control = false;
                    }
                }
            });
        },
        async finalize() {
            if (this.editing) {
                await this.updateTask();
            } else {
                await this.addTask();
            }
        },
        validateFormControls() {
            this.$validator.validateAll('task_control')
                .then((result) => {
                    if (result) {
                        if (this.editing_control) {
                            if (!this.task_control.image && this.task_control.url) {
                                delete this.task_control.image;
                            }
                            this.updateControl();
                        } else {
                            this.addControl();
                        }

                        this.resetTaskControl();
                        this.form_control = false;
                        this.setEditingControl(false);
                    }
                });
        },
        onFileChange(e) {
            const file = e.target.files[0];
            this.imageTypeError = '';
            this.task_control.image = null;

             if (!file) return;
            
            const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
            const maxSize = 20 * 1024 * 1024; // 20MB
          
            if (!validTypes.includes(file.type)) {
                this.imageTypeError = 'Solo se permiten imágenes PNG o JPG.';
              } else if (file.size > maxSize) {
                this.imageTypeError = 'El tamaño máximo permitido es 20MB.';
            } else {
                this.task_control.image = file;
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = e => {
                    this.setUrlToTaskControl(e.target.result);
                };
                return;
            }          
            e.target.value = '';            
        }
    }
};
</script>

<style>
.component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .3s ease;
}

.component-fade-enter, .component-fade-leave-to {
    opacity: 0;
}
</style>
